module.exports = __webpack_public_path__ + "static/media/icons_grey_flip-up.2d7f413b.svg";